import React, { Component } from 'react';
import styled from 'styled-components';
import {Grid, Popper, Paper} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SecondaryButton from 'components/Global/Buttons/SecondaryButton';
import _ from 'lodash';
import {
  AlignedGrid, 
  QuoteComparisonExpansionPanel,   
  createLoanGridLabel,  
  RightAlignedDiv,
  QuoteComparisonExpansionSummary,
  QuoteComparisonExpansionPanelDetails,
} from './QuoteComparisonGridElements';

const OtherContainer = styled.p`
  && {
    border: 1px solid #14a5e2;
    border-radius: 4px;
    max-width:400px;
    max-height:300px;
    overflow:auto;
    padding: 12px;
  }
`

const CustomGridItem = styled(Grid)`
  && {
    padding:8px;
  }
`
const AlterGridItem = styled(Grid)`
  &&& {
    background:#f5f5f5;
    padding:8px;
  }
`
const NoneGrid = styled(Grid)`
  && {
    height:100%;
  }
`
const OverflowTextContainer = styled.div`
  && {
    max-height:${props => props.isCombined ? '420px;' : '350px;'   }
    overflow:hidden;    
    text-align:left;
  }
`
const TextContainer = styled.div`
  && {
    max-height:${props => props.isCombined ? '420px;' : '350px;'   }
    text-align:left;
  }
`
const ContentText = styled.div`
  & {
    height:100%    
    font-size:17px;
    text-align:right;
  }
`;
class Other extends Component {
  state = {
    expanded:true,
    isPopperOpen:{

    },
  }

  handleChange = (event, expanded) => {
    this.setState({
      expanded: expanded,
      isPopperOpen:{},
    });
  }

  togglePopper = (event, id) => {
    const {currentTarget} = event;
    event.stopPropagation();
    const isLoanPopperOpen = Boolean(this.state.isPopperOpen[id]);
    this.setState({
      isPopperOpen: {        
        [id]: !isLoanPopperOpen
      },
      anchorEl: currentTarget
    })
  }  

  customElements = (loans, renderer,placeholder, isCombined) => {
    let gridCol;
    if (loans.length <= 2) {
      gridCol = 4;
    } else if (loans.length >= 6) {
      gridCol = 1;
    } else if (loans.length >= 3) {
      gridCol = 2;
    } else {
      gridCol = 3;
    }

    return loans.map((x,i) => {
      if(x.isExistingFinancing || x.originalLoan)
        return (
            <AlterGridItem item xs={gridCol} key={`AlterGridItem${placeholder}+${i}`}>
              <ContentText key={`ContentText${placeholder}+${i}`}>{renderer(x,placeholder)}</ContentText>
            </AlterGridItem>
          )
      else
        return (
          <CustomGridItem item xs={gridCol} key={`CustomGridItem${placeholder}+${i}`}>
            <ContentText key={`ContentText${placeholder}+${i}`}>{renderer(x,placeholder)}</ContentText>
          </CustomGridItem>
        )      
      }
    );
  }

  renderMultiLineString = (value) => {
      if(value)
          return value.split('|').map((text, index) => (<React.Fragment key={`other-${index}`}>{text}<br /></React.Fragment>));
  }

  otherRenderer = (loan, placeholder) => {
    const {isPopperOpen, anchorEl} = this.state;
    var other = _.get(loan, 'other', null);
    if(!other) {
      return (<NoneGrid item container alignItems="center" justify="flex-end">{placeholder}</NoneGrid>)
    }
    if(other.length < 100){
      return (
        <RightAlignedDiv>
        <TextContainer>{this.renderMultiLineString(other)}</TextContainer>
        </RightAlignedDiv>
      )
    }
    return (
      <RightAlignedDiv>
        <OverflowTextContainer>{this.renderMultiLineString(other.substring(0, 150))} <span>...</span></OverflowTextContainer>        
        <SecondaryButton onClick={(e) => this.togglePopper(e,loan.loanId)}>{isPopperOpen[loan.loanId] ? 'close' : 'open'}</SecondaryButton>
        <Popper open={isPopperOpen[loan.loanId]} anchorEl={anchorEl} placement='bottom'>
          <Paper>
            <OtherContainer>{this.renderMultiLineString(other)}</OtherContainer>
          </Paper>
        </Popper>
      </RightAlignedDiv>
    )
  }

  render() {
    const { loans,isCombined } = this.props;
    const { expanded } = this.state;
    return (
      <QuoteComparisonExpansionPanel onChange={this.handleChange} defaultExpanded>
        <QuoteComparisonExpansionSummary expandIcon={<ExpandMoreIcon />} expanded={expanded}>
          <Grid container direction="row" alignItems="stretch">
            {createLoanGridLabel("Other")}
            {expanded && this.customElements(loans, this.otherRenderer, isCombined ? '\u2014' : 'None', isCombined)}
          </Grid>
        </QuoteComparisonExpansionSummary>
        <QuoteComparisonExpansionPanelDetails>
          <AlignedGrid container direction="row" justify="flex-start" alignItems="stretch">
          </AlignedGrid>
        </QuoteComparisonExpansionPanelDetails>
      </QuoteComparisonExpansionPanel>
    )
  }
}

export default Other;